import classNames from "classnames/bind";
import { ProductCard } from "../ProductCard";
import { ProductListLayout } from "../../types/types";
import styles from "./FlexGrid.module.scss";
import { getProductKey } from "../utils/getProductKey";
import { ColumnStyles } from "../shared/ColumnStyles";

const cx = classNames.bind(styles);

const justifyContentValues = [
  "flex-start",
  "center",
  "flex-end",
  "space-between",
  "space-around",
  "space-evenly",
] as const;

type JustifyContent = (typeof justifyContentValues)[number];

const defaultJustifyContent: JustifyContent = "flex-start";

const validateJustifyContent = (value: unknown): JustifyContent =>
  (justifyContentValues as readonly unknown[]).includes(value)
    ? (value as JustifyContent)
    : defaultJustifyContent;

export const FlexGrid: ProductListLayout = ({
  configProps,
  config,
  products,
  instanceId,
  consumerId,
}) => {
  const justifyContent = validateJustifyContent(configProps?.justifyContent);

  return (
    <>
      <ColumnStyles
        columnsByBreakpoint={configProps?.columnsByBreakpoint}
        className={cx("flex-container")}
      />
      <section
        className={cx("flex-container")}
        style={{ justifyContent }}
        data-testid="flex-grid-container"
      >
        {products.map((product, ind) => (
          <ProductCard
            key={getProductKey(product)}
            product={product}
            config={config}
            index={ind}
            instanceId={instanceId}
            consumerId={consumerId}
          />
        ))}
      </section>
    </>
  );
};
